const vehiculos = [
  { id: "TURISMO", nombre: "Turismo" },
  { id: "FURGONETA", nombre: "Furgoneta" },
  { id: "ADAPTADO", nombre: "Vehículo adaptado" },
  { id: "OTROS", nombre: "Otros / Sin detallar" },
  { id: "NO", nombre: "No dispongo de vehículo" },
];

export default vehiculos;
